import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const PrivacyPolicy: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-container">
      <div className="legal-content">
        <h1>Politique de Confidentialité</h1>
        <p className="last-updated">Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}</p>

        <section>
          <h2>1. Responsable du traitement</h2>
          <p>
            <strong>Hugo Bachellier - Entreprise individuelle</strong><br />
            SIREN : 924 766 702<br />
            Adresse : 9 Allée de la Fauvette, 37100 Tours, France<br />
            Email : <a href="mailto:bobmap.contact@gmail.com">bobmap.contact@gmail.com</a>
          </p>
        </section>

        <section>
          <h2>2. Données collectées</h2>
          <p>Dans le cadre de l'utilisation de Bob Map, nous collectons les données personnelles suivantes :</p>

          <h3>2.1 Données d'identification</h3>
          <ul>
            <li>Nom et prénom</li>
            <li>Adresse email</li>
            <li>Numéro de téléphone (optionnel)</li>
            <li>Photo de profil (optionnel)</li>
          </ul>

          <h3>2.2 Données de localisation</h3>
          <ul>
            <li>Adresse postale complète (rue, ville, code postal, pays)</li>
            <li>Coordonnées géographiques (latitude, longitude)</li>
            <li>Localisations temporaires (vacances, événements)</li>
          </ul>

          <h3>2.3 Données de connexion</h3>
          <ul>
            <li>Mot de passe (chiffré avec bcrypt)</li>
            <li>Token d'authentification (JWT)</li>
            <li>Données OAuth Google (si connexion via Google)</li>
          </ul>

          <h3>2.4 Données d'interaction sociale</h3>
          <ul>
            <li>Liste d'amis</li>
            <li>Demandes d'amitié</li>
            <li>Groupes d'amis</li>
            <li>Notes sur les amis (privées)</li>
            <li>Paramètres de visibilité par ami/groupe</li>
          </ul>
        </section>

        <section>
          <h2>3. Finalités du traitement</h2>
          <p>Vos données personnelles sont collectées et traitées pour les finalités suivantes :</p>
          <ul>
            <li><strong>Création et gestion de votre compte</strong> : Identification, authentification</li>
            <li><strong>Fonctionnalités principales</strong> : Affichage de votre localisation et celle de vos amis sur une carte interactive</li>
            <li><strong>Gestion des relations sociales</strong> : Demandes d'amitié, groupes, notifications</li>
            <li><strong>Personnalisation de l'expérience</strong> : Paramètres de visibilité, préférences linguistiques</li>
            <li><strong>Sécurité</strong> : Prévention de la fraude et des abus</li>
            <li><strong>Support utilisateur</strong> : Réponse à vos demandes</li>
          </ul>
        </section>

        <section>
          <h2>4. Base légale du traitement</h2>
          <p>Le traitement de vos données repose sur :</p>
          <ul>
            <li><strong>Votre consentement</strong> (Article 6.1.a RGPD) : Vous consentez explicitement au traitement de vos données lors de votre inscription</li>
            <li><strong>L'exécution du contrat</strong> (Article 6.1.b RGPD) : Le traitement est nécessaire pour fournir le service Bob Map</li>
          </ul>
          <p>
            Vous pouvez retirer votre consentement à tout moment en supprimant votre compte depuis la page{' '}
            <Link to="/my-data">Mes Données</Link>.
          </p>
        </section>

        <section>
          <h2>5. Destinataires des données</h2>
          <p>Vos données personnelles sont accessibles aux personnes suivantes :</p>
          <ul>
            <li><strong>Vos amis acceptés</strong> : Selon vos paramètres de visibilité (niveau 1 à 5)</li>
            <li><strong>L'éditeur du service</strong> : Pour la gestion technique et le support</li>
            <li><strong>L'hébergeur</strong> : Railway Inc. (États-Unis) - Voir section 7</li>
          </ul>
          <p><strong>Nous ne vendons jamais vos données à des tiers.</strong></p>
        </section>

        <section>
          <h2>6. Durée de conservation</h2>
          <ul>
            <li><strong>Compte actif</strong> : Tant que votre compte est actif</li>
            <li><strong>Après suppression</strong> : Suppression immédiate de vos données personnelles</li>
            <li><strong>Logs techniques</strong> : Conservés 1 an maximum pour des raisons de sécurité</li>
            <li><strong>Données archivées</strong> : 1 an après suppression pour raisons légales (puis suppression définitive)</li>
          </ul>
        </section>

        <section>
          <h2>7. Transferts internationaux</h2>
          <p>
            Vos données sont hébergées sur les serveurs de <strong>Railway Inc.</strong> (États-Unis).
            Railway est conforme aux standards de sécurité internationaux. En utilisant Bob Map, vous
            consentez à ce transfert de données hors Union Européenne.
          </p>
          <p>
            Des garanties appropriées sont mises en place conformément aux articles 44 et suivants du RGPD.
          </p>
        </section>

        <section>
          <h2>8. Sécurité des données</h2>
          <p>Nous mettons en œuvre les mesures de sécurité suivantes :</p>
          <ul>
            <li>Chiffrement des mots de passe (bcrypt, facteur 10)</li>
            <li>Connexions HTTPS (chiffrement SSL/TLS)</li>
            <li>Tokens JWT avec expiration (7 jours)</li>
            <li>Protection CORS et Rate Limiting</li>
            <li>Système de visibilité granulaire (5 niveaux)</li>
            <li>Base de données PostgreSQL sécurisée</li>
          </ul>
        </section>

        <section>
          <h2>9. Vos droits (RGPD)</h2>
          <p>Conformément au RGPD, vous disposez des droits suivants :</p>

          <h3>9.1 Droit d'accès (Article 15)</h3>
          <p>Vous pouvez demander une copie de toutes vos données personnelles.</p>

          <h3>9.2 Droit de rectification (Article 16)</h3>
          <p>
            Vous pouvez modifier vos données depuis la page <Link to="/profile">Profil</Link>.
          </p>

          <h3>9.3 Droit à l'effacement (Article 17)</h3>
          <p>
            Vous pouvez supprimer votre compte et toutes vos données depuis la page{' '}
            <Link to="/my-data">Mes Données</Link>.
          </p>

          <h3>9.4 Droit à la portabilité (Article 20)</h3>
          <p>
            Vous pouvez télécharger toutes vos données au format JSON depuis la page{' '}
            <Link to="/my-data">Mes Données</Link>.
          </p>

          <h3>9.5 Droit d'opposition (Article 21)</h3>
          <p>Vous pouvez vous opposer au traitement de vos données en supprimant votre compte.</p>

          <h3>9.6 Droit de limitation (Article 18)</h3>
          <p>Vous pouvez limiter la visibilité de vos données via les paramètres de confidentialité.</p>

          <p>
            Pour exercer ces droits, contactez-nous à{' '}
            <a href="mailto:bobmap.contact@gmail.com">bobmap.contact@gmail.com</a>
          </p>
        </section>

        <section>
          <h2>10. Cookies et technologies similaires</h2>
          <p>
            Bob Map utilise <strong>uniquement le localStorage</strong> pour stocker votre token d'authentification.
            Aucun cookie de tracking ou de publicité n'est utilisé.
          </p>
          <p>
            Le localStorage n'est pas soumis au consentement des cookies selon la directive ePrivacy.
          </p>
        </section>

        <section>
          <h2>11. Données des mineurs</h2>
          <p>
            Bob Map est destiné aux personnes majeures (18 ans et plus). Si vous êtes mineur, vous devez
            obtenir le consentement de vos parents ou tuteurs légaux avant de créer un compte.
          </p>
        </section>

        <section>
          <h2>12. Modifications de la politique</h2>
          <p>
            Nous nous réservons le droit de modifier cette politique de confidentialité à tout moment.
            Les modifications seront notifiées par email et affichées sur cette page avec la nouvelle
            date de mise à jour.
          </p>
        </section>

        <section>
          <h2>13. Réclamations</h2>
          <p>
            Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation
            auprès de la <strong>CNIL</strong> (Commission Nationale de l'Informatique et des Libertés) :
          </p>
          <p>
            <strong>CNIL</strong><br />
            3 Place de Fontenoy - TSA 80715<br />
            75334 PARIS CEDEX 07<br />
            Téléphone : 01 53 73 22 22<br />
            Site web : <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">www.cnil.fr</a>
          </p>
        </section>

        <section>
          <h2>14. Contact</h2>
          <p>
            Pour toute question concernant cette politique de confidentialité ou l'exercice de vos droits,
            contactez-nous :
          </p>
          <p>
            Email : <a href="mailto:bobmap.contact@gmail.com">bobmap.contact@gmail.com</a><br />
            Adresse : 9 Allée de la Fauvette, 37100 Tours, France
          </p>
        </section>

        <div className="legal-footer">
          <Link to="/terms" className="legal-link">Conditions Générales d'Utilisation</Link>
          <Link to="/legal" className="legal-link">Mentions Légales</Link>
          <Link to="/my-data" className="legal-link">Gérer mes données</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
